import script from "./DeliveryUpgradeHint.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliveryUpgradeHint.vue?vue&type=script&setup=true&lang=js"

import "./DeliveryUpgradeHint.vue?vue&type=style&index=0&id=06c9b79a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c9b79a"]])

export default __exports__